import React from "react";
import type { View } from "../../types";
import { useBilling } from "../../store/BillingContext";
import { useAuth } from "../../store/AuthContext";

const navItems: [View, string, string][] = [
  ["dashboard", "Dashboard", "fa-chart-pie"],
  ["invoices", "Invoices", "fa-file-invoice-dollar"],
  ["quotations", "Quotations", "fa-file-lines"],
  ["accounting", "Accounting & P&L", "fa-scale-balanced"],
  ["expenses", "Business Expenses", "fa-wallet"],
  ["clients", "Clients", "fa-users"],
  ["services", "Services & Rates", "fa-box-open"],
  ["settings", "Agency Settings", "fa-gear"],
];

export const Sidebar: React.FC = () => {
  const { view, setView, state } = useBilling();
  const { user, logout } = useAuth();

  return (
    <aside>
      <div className="logo">
        <img src="/logo.png" alt="Revival Softech" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        <div>
          <b>
            Revival <em>Softech</em>
          </b>
          <small>Billing Hub</small>
        </div>
      </div>

      <nav>
        {navItems.map(([v, label, icon]) => {
          const isActive = view === v;
          let count = 0;
          if (v === "invoices") count = state.invoices.length;
          if (v === "quotations") count = state.quotes.length;
          if (v === "clients") count = state.clients.length;

          return (
            <button
              key={v}
              className={isActive ? "active" : ""}
              onClick={() => setView(v)}
            >
              <i className={`fa-solid ${icon}`} />
              <span style={{ flex: 1 }}>{label}</span>
              {count > 0 && (
                <span
                  style={{
                    fontSize: "11px",
                    background: isActive ? "rgba(255,255,255,0.2)" : "#173b60",
                    padding: "2px 7px",
                    borderRadius: "10px",
                    color: isActive ? "#ffffff" : "#a1b4c4",
                    fontWeight: 600,
                  }}
                >
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      <div className="profile">
        <div className="profile-inner">
          <span className="dot" />
          <div className="profile-details">
            <b title={user?.email || "revivalsoftech@gmail.com"}>
              {user?.email || "revivalsoftech@gmail.com"}
            </b>
            <small>Active Secure Session</small>
          </div>
          <button
            className="sidebar-logout-btn"
            onClick={logout}
            title="Sign out of Billing Hub"
          >
            <i className="fa-solid fa-arrow-right-from-bracket" />
          </button>
        </div>
      </div>
    </aside>
  );
};
